/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookingDiagnosticsRequest,
    BookingDiagnosticsRequestFromJSON,
    BookingDiagnosticsRequestToJSON,
    BookingDiagnosticsResult,
    BookingDiagnosticsResultFromJSON,
    BookingDiagnosticsResultToJSON,
    BookingLogsResult,
    BookingLogsResultFromJSON,
    BookingLogsResultToJSON,
    DownloadFileInfo,
    DownloadFileInfoFromJSON,
    DownloadFileInfoToJSON,
} from '../models';

export interface ApiBookingDiagnosticsGetBookingLogsGetRequest {
    correlationId?: string;
}

export interface ApiBookingDiagnosticsGetProviderMessageGetRequest {
    correlationId?: string;
    requestId?: string;
    request?: boolean;
}

export interface ApiBookingDiagnosticsRetrieveBookingPostRequest {
    bookingDiagnosticsRequest?: BookingDiagnosticsRequest;
}

/**
 * no description
 */
export class BookingDiagnosticsApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingDiagnosticsGetBookingLogsGetRaw(requestParameters: ApiBookingDiagnosticsGetBookingLogsGetRequest): Promise<runtime.ApiResponse<BookingLogsResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.correlationId !== undefined) {
            queryParameters['correlationId'] = requestParameters.correlationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingDiagnostics/GetBookingLogs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingLogsResultFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingDiagnosticsGetBookingLogsGet(requestParameters: ApiBookingDiagnosticsGetBookingLogsGetRequest): Promise<BookingLogsResult> {
        const response = await this.apiBookingDiagnosticsGetBookingLogsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingDiagnosticsGetProviderMessageGetRaw(requestParameters: ApiBookingDiagnosticsGetProviderMessageGetRequest): Promise<runtime.ApiResponse<DownloadFileInfo>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.correlationId !== undefined) {
            queryParameters['correlationId'] = requestParameters.correlationId;
        }

        if (requestParameters.requestId !== undefined) {
            queryParameters['requestId'] = requestParameters.requestId;
        }

        if (requestParameters.request !== undefined) {
            queryParameters['request'] = requestParameters.request;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingDiagnostics/GetProviderMessage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DownloadFileInfoFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingDiagnosticsGetProviderMessageGet(requestParameters: ApiBookingDiagnosticsGetProviderMessageGetRequest): Promise<DownloadFileInfo> {
        const response = await this.apiBookingDiagnosticsGetProviderMessageGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingDiagnosticsRetrieveBookingPostRaw(requestParameters: ApiBookingDiagnosticsRetrieveBookingPostRequest): Promise<runtime.ApiResponse<BookingDiagnosticsResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingDiagnostics/RetrieveBooking`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingDiagnosticsRequestToJSON(requestParameters.bookingDiagnosticsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingDiagnosticsResultFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingDiagnosticsRetrieveBookingPost(requestParameters: ApiBookingDiagnosticsRetrieveBookingPostRequest): Promise<BookingDiagnosticsResult> {
        const response = await this.apiBookingDiagnosticsRetrieveBookingPostRaw(requestParameters);
        return await response.value();
    }

}
